import React from "react";
import "./Landing Page.css";
import BentoBox from "./Bento Box";
import Lander from "./Lander";
import Cards from "./Cards";
import Tabs from "./Tabs";
import Mobilex from "./Mobilex";
import { useState, useEffect } from "react";


export default function LandingPage() {


    return (

        <div className="landing-page-container">
            <Lander />
            <Cards />
            <BentoBox />
            <Tabs />
            <Mobilex />
        </div>
    );
}